export default "__VITE_ASSET__olDAlgsi__"